import { Eyebrow, Reveal } from "./Reveal";

const CREDS = [
  {
    tag: "Certification · 2025",
    name: "Rajiv Vermani",
    title: "Certified Technical Operator, Kestrel TSCM Professional Software",
    issuer: "Professional Development, TSCM Group Inc., Technical Security Branch",
    text: "A 36-hour programme of advanced instruction and practical exercises in software-defined radio spectrum work, issued under Paul D Turner, TSS TSI.",
    date: "Issued 4 May 2025",
  },
  {
    tag: "Training · 2013",
    name: "Rajiv Vermani",
    title: "Level 1 Thermographer training, Infrared Training Center, Stockholm",
    issuer: "",
    text: "Formal training in thermal imaging, the discipline behind locating powered electronics concealed behind finished surfaces.",
    date: "Completed November 2013",
  },
];

export default function Credentials() {
  return (
    <section id="credentials" className="border-t border-hairline py-12 sm:py-16" data-testid="credentials-section">
      <div className="site-x">
        <Reveal>
          <Eyebrow>Credentials</Eyebrow>
          <h3 className="mt-4 font-head font-extrabold tracking-tight h-sec">
            Named people, named training.
          </h3>
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-sub">
            Most providers in this market describe their teams as trained by
            former intelligence officials without naming a person, a course or
            a year. Ours are on the record.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {CREDS.map(({ tag, name, title, issuer, text, date }, i) => (
            <Reveal key={title} delay={i * 0.1} className="h-full">
              <article className="flex h-full flex-col border border-hairline bg-surface p-7 sm:p-9" data-testid={`credential-card-${i + 1}`}>
                <p className="text-[0.625rem] font-semibold uppercase tracking-[0.16em] text-violet">
                  {tag}
                </p>
                <h4 className="mt-4 font-head text-lg font-bold">{name}</h4>
                <p className="mt-1 font-head text-base font-bold leading-snug">{title}</p>
                {issuer && (
                  <p className="mt-2 text-[0.625rem] uppercase leading-relaxed tracking-[0.16em] text-sub">
                    {issuer}
                  </p>
                )}
                <p className="mt-4 flex-1 text-base leading-relaxed text-sub">{text}</p>
                <div className="mt-6 border-t border-hairline pt-4">
                  <span className="text-[0.625rem] uppercase tracking-[0.16em] text-sub">{date}</span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
